<template>
  <section class="site-top-menu">
    <div>
      <b-nav tabs ref="topMenu">
        <b-nav-item :to="{name: 'analytics'}" :active="this.$router.currentRoute.name == 'analytics'">
          Аналитика продаж по странам
        </b-nav-item>

        <b-nav-item :to="{name: 'salesAnalyticsCountryBrand', params: {id: siteId}}"
                    :active="this.$router.currentRoute.name == 'salesAnalyticsCountryBrand'"
        >
          Аналитика продаж по странам и брендам
        </b-nav-item>
      </b-nav>
    </div>
  </section>
</template>

<script>
export default {
  name: "topMenu",
  props: {
    siteId: String
  }
}
</script>

<style scoped>
.translation-top-menu {
  margin-bottom: 20px;
}
</style>